import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/onest';
import './index.css';
import App from './App';
import { setHttpToken } from './api/httpClient';
import { readAuthToken } from './modules/auth/authStorage';
import reportWebVitals from './reportWebVitals';

const storedAuthToken = readAuthToken();

setHttpToken(storedAuthToken?.access_token ?? null);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
